/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MusicIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABIElEQVR4nN3UsUrEQBAG4A02lrZWtteKD2BjJZmZ/w7iTM4ijdpeoSdYCD6DtZUPYeEziKI2dno2dhaijQhKECHqbcyGPUR/SLOE/XZ+snHutyJSzBBsh0R3mW0+OsBiRwx7/XgIdkWie2kv70QBSPS5CnzG9IzEtpd7/bn2E3g25+/YCUMH3e7qbEtA91ns7kdI7IVFj4H+QhDgnHNZlk0xrywx7ICh9/UT2XUwUE0FOyTYwzjENUmTlxeLYlokpxJj2FN04Ou9mShQ5n8DCUE3WOySoY8EPY0KMHTo+65dDIBgtxMFGDYaC4je1OzXvNZUdMvzf9n0nzas1oRh6wS9eL+Rei6Sr5XrNXWMYtTqTctamydtUWtoktBa/2beADZSTCGOVnoUAAAAAElFTkSuQmCC)
 */
export const MusicIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8.65 1.51A2 2 0 0 0 6 3.41v9.88A3.98 3.98 0 0 0 4.5 13C2.57 13 1 14.34 1 16s1.57 3 3.5 3S8 17.66 8 16V5.4l11 3.81v7.08a3.98 3.98 0 0 0-1.5-.29c-1.93 0-3.5 1.34-3.5 3s1.57 3 3.5 3 3.5-1.34 3.5-3V7.03c0-.74-.47-1.4-1.18-1.65L8.65 1.51Z"
        className={colorClass}
      />
    </svg>
  );
};
